import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTeamPageLayoutContext } from "../TeamPageLayout";
import { CreateResourceModal, TeamResources } from "./components";

const TeamResourcesPage = () => {
  const { team } = useTeamPageLayoutContext();
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Stack spacing={{ xs: 0.75, md: 1 }}>
        <Card>
          <CardContent>
            <Stack spacing={1} direction="row" alignItems="center">
              <Stack spacing={0.25} sx={{ flexGrow: 1 }}>
                <Typography variant="h5">Resources</Typography>
                <Typography variant="body1">Resources relevant to the team.</Typography>
              </Stack>

              {(team.isAdministrator || team.isMember) && (
                <Button variant="contained" onClick={() => setIsModalVisible(true)}>
                  Add Resource
                </Button>
              )}
            </Stack>
          </CardContent>
        </Card>

        {team.hasResources && (
          <Card>
            <TeamResources isEditable={team.isAdministrator || team.isMember} />
          </Card>
        )}
      </Stack>

      <CreateResourceModal
        visible={isModalVisible}
        onAdded={() => setIsModalVisible(false)}
        onCancelled={() => setIsModalVisible(false)}
      />
    </>
  );
};

export { TeamResourcesPage };
